import store from "../../redux/configureStore";
export const getLookupByListing = ({ LookupNames, getLookups }) => {
    const state = store.getState();
    const lookupState = state.lookups;
    if (!LookupNames || !Array.isArray(LookupNames) || LookupNames.length === 0) {
        return;
    }
    const requiredLookups = LookupNames.filter((item) => !lookupState[item] || lookupState[item].length === 0);
    if (requiredLookups.length > 0) {
        getLookups(requiredLookups);
    }
};
